export default __webpack_public_path__ + "static/media/prelaunch-icon.a7beb066.png";